import { render } from "./EnterAccountPage.vue?vue&type=template&id=346fd5e9&scoped=true"
import script from "./EnterAccountPage.vue?vue&type=script&lang=ts"
export * from "./EnterAccountPage.vue?vue&type=script&lang=ts"

import "./EnterAccountPage.vue?vue&type=style&index=0&id=346fd5e9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-346fd5e9"
/* hot reload */
if (module.hot) {
  script.__hmrId = "346fd5e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('346fd5e9', script)) {
    api.reload('346fd5e9', script)
  }
  
  module.hot.accept("./EnterAccountPage.vue?vue&type=template&id=346fd5e9&scoped=true", () => {
    api.rerender('346fd5e9', render)
  })

}

script.__file = "src/views/registerTeam/EnterAccountPage.vue"

export default script